var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcess02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_1412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8076 40V27.5C67.8076 27.5 67.8076 25 65.3076 22.5L47.8076 5C45.3076 2.5 42.8076 2.5 42.8076 2.5M42.8076 2.5H5.30762C5.30762 2.5 2.80762 2.5 2.80762 5V75C2.80762 75 2.80762 77.5 5.30762 77.5H45.3076M42.8076 2.5V25C42.8076 25 42.8076 27.5 45.3076 27.5H57.8076M57.8076 62.5H67.8076M62.8076 67.5V57.5M77.8076 62.5C77.8076 54.2175 71.0901 47.5 62.8076 47.5C54.5251 47.5 47.8076 54.2175 47.8076 62.5C47.8076 70.7825 54.5251 77.5 62.8076 77.5C71.0901 77.5 77.8076 70.7825 77.8076 62.5Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.307617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess02);
export default __webpack_public_path__ + "static/media/icon_process_02.f9f247c0358ee1bc25b762f5e9d930bc.svg";
export { ForwardRef as ReactComponent };